import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import DonateButton from './DonateButton';
import { Email as EmailIcon, WhatsApp as WhatsAppIcon } from '@mui/icons-material';

// Pied de page commun (portail public et interface d'administration).
// Les coordonnees sont ici, a un seul endroit : modifier ce bloc suffit pour tout le site.
const COMPANY = {
  name: 'TchoukHeadCorp',
  site: 'https://tchoukheadcorp.net',
  email: 'accueil@tchoukheadcorp.net',
  whatsapp: '+237690152052',
  year: 2025,
};
const whatsappLink = `https://wa.me/${COMPANY.whatsapp.replace(/\D/g, '')}`;

function SiteFooter() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 4,
        py: 2.5,
        px: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        textAlign: 'center',
      }}
    >
      <Link href={COMPANY.site} target="_blank" rel="noopener noreferrer" aria-label={COMPANY.name} sx={{ display: 'inline-block' }}>
        <Box component="img" src="/brand/tchoukheadcorp.png" alt={`Logo ${COMPANY.name}`} width={64} height={64} sx={{ display: 'block', mx: 'auto', mb: 0.5 }} />
      </Link>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 560, mx: 'auto' }}>
        Ce site a été encapsulé et propulsé par{' '}
        <Link href={COMPANY.site} target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontWeight: 600 }}>
          {COMPANY.site.replace('https://', '')}
        </Link>
        . Copyright © {COMPANY.year}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: { xs: 1.5, sm: 3 }, flexWrap: 'wrap', mt: 1 }}>
        <Link href={`mailto:${COMPANY.email}`} underline="hover" variant="body2" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
          <EmailIcon fontSize="small" /> {COMPANY.email}
        </Link>
        <Link href={whatsappLink} target="_blank" rel="noopener noreferrer" underline="hover" variant="body2" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
          <WhatsAppIcon fontSize="small" sx={{ color: '#25d366' }} /> {COMPANY.whatsapp}
        </Link>
      </Box>
      <Box sx={{ mt: 1.5 }}><DonateButton /></Box>
    </Box>
  );
}

export default SiteFooter;
